import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '../providers/AuthUserProvider';

import { getDefaultPathForRole } from './getDefaultPathForRole';
import { Paths } from './Paths';

export const AppPublic = () => {
  const { user } = useAuth();
  const location = useLocation();

  if (user && location.pathname === Paths.Login) {
    return <Navigate to={getDefaultPathForRole(user.role)} replace />;
  }

  return <Outlet />;
};
